module.exports = __webpack_public_path__ + "static/media/rutabaga.0e614cfb.jpg";